import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Service from '../components/Service/Service'
import Contactfooter from '../components/Contactfooter'


const Servicepage = () => {
    return (
        <div>
            <Navbar />
          

            <Service />

            <Contactfooter />



            <Footer />

        </div>
    )
}

export default Servicepage